// extracted by mini-css-extract-plugin
module.exports = {"shareModal":"_3MLhZF","shareButton":"_3kQKv7"};